import { render, staticRenderFns } from "./AdsCampaignEventsList.vue?vue&type=template&id=001b4640"
import script from "./AdsCampaignEventsList.vue?vue&type=script&lang=js"
export * from "./AdsCampaignEventsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports